import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const overviewSummaryEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-business-overview-summary-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
